export default "__VITE_ASSET__COSEibrX__"